import React from 'react';

import AuthWrapper from '../../../login/AuthWrapper';

import { tripi, dinogo, vnpay } from '../../../../assets/index';

import './Partner.scss';

const menu = [
  {
    id: 0,
    logo: tripi,
  },
  {
    id: 1,
    logo: dinogo,
  },
  {
    id: 2,
    logo: vnpay,
  },
];

const Partner = () => {
  return (
    <div className='partner_home'>
      <div className='title'>
        Đối tác
        <div className='line' />
      </div>

      <div className='wrapListItem'>
        <div className='listItem'>
          {menu.map((el, index) => (
            <div className='item' key={index}>
              <div className='icon'>
                <img src={el.logo} alt='' />
              </div>
            </div>
          ))}
        </div>
        <div className='register'>
          <AuthWrapper typeModal='REGISTER_MODAL'>
            <div className='box'>
              <span> Đăng ký tham gia</span>
            </div>
          </AuthWrapper>
        </div>
      </div>
    </div>
  );
};

export default Partner;
